// Internal imports (Redux slice)
import { fetchCustomersStart, fetchCustomersSuccess, fetchCustomersFailure } from './customerSlice';

// External imports (Libraries)
import { takeLatest, put, call, CallEffect, PutEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';

// API Services
import { ContractService } from '@/api/services/contractService';

// Models
import { Customer } from '@/api/models/Customer';
import { CustomerRequest } from '@/api/models/BaseRequest';

/**
 * Saga to fetch customers from the API.
 * @param action - Payload containing clientId.
 */
function* fetchCustomersSaga(
  action: PayloadAction<{ clientId: string }>,
): Generator<CallEffect<Customer[]> | PutEffect, void, Customer[]> {
  try {
    const payload: CustomerRequest = {
      keyword: '',
      pageNo: 0,
      pageSize: 0,
      clientId: action.payload.clientId,
    };

    // Fetch customers using ContractService
    const customers: Customer[] = yield call(ContractService.fetchCustomers, payload);

    // Dispatch success action with retrieved customers
    yield put(fetchCustomersSuccess(customers));
  } catch (error: unknown) {
    // Handle errors and dispatch failure action
    const errorMessage = error instanceof Error ? error.message : 'Fetching customers failed';
    yield put(fetchCustomersFailure(errorMessage));
  }
}

/**
 * Watcher saga to listen for fetchCustomersStart action.
 */
export function* watchCustomers(): SagaIterator {
  yield takeLatest(fetchCustomersStart.type, fetchCustomersSaga);
}
